import React, { useEffect } from 'react'
import Navbar from './Navbar/Navbar'
import BreadCrumbNav from './Navbar/BreadCrumbNav'
import ListingPageCarousel from './Hero/ListingPageCarousel'
import TractorFilter from './Filter/TractorFilter'
import TractorListings from './Tractor/TractorListings'
import { Collapse } from 'antd';
import Footer from './Footer'
import QuickLinks from './Navbar/QuickLinks'


const { Panel } = Collapse;

function UpcomingTractors() {
    useEffect(() => window.scrollTo(0, 0), [])

  return (
    <div>
        <Navbar />
        
        <BreadCrumbNav items={["Upcoming Tractors"]} />
        
        <ListingPageCarousel />

        <div className="mx-4 mb-3 bg-white rounded shadow">
            <p className="px-4 py-2 text-2xl font-bold border-b text-gray-600">
                Upcoming Tractors
            </p>
            <Collapse expandIconPosition="right" ghost>
                <Panel header={
                        <p className="p-4 text-xs text-gray-700">
                            Most popular tractor in India with their detailed specifications and a fair price is shown below only on TractorJunction at a single place. Here you can also get all the brands popular tractors with their popular tractor price. Popular tractors in India are Swaraj 744 FE, Massey Ferguson 241 DI Maha Shakti, Mahindra 475 DI, and many more.
                        </p>
                    } key="1" showArrow={false}>
                    <p className="pb-4 px-4 -mt-4 text-xs text-gray-700">
                        Most popular tractor in India with their detailed specifications and a fair price is shown below only on TractorJunction at a single place. Here you can also get all the brands popular tractors with their popular tractor price. Popular tractors in India are Swaraj 744 FE, Massey Ferguson 241 DI Maha Shakti, Mahindra 475 DI, and many more.
                        Most popular tractor in India with their detailed specifications and a fair price is shown below only on TractorJunction at a single place. Here you can also get all the brands popular tractors with their popular tractor price. Popular tractors in India are Swaraj 744 FE, Massey Ferguson 241 DI Maha Shakti, Mahindra 475 DI, and many more.
                        Most popular tractor in India with their detailed specifications and a fair price is shown below only on TractorJunction at a single place. Here you can also get all the brands popular tractors with their popular tractor price. Popular tractors in India are Swaraj 744 FE, Massey Ferguson 241 DI Maha Shakti, Mahindra 475 DI, and many more.
                    </p>
                </Panel>
            </Collapse>
        </div>

        <div className="mx-4 mb-3 md:grid md:grid-cols-4 md:gap-5">
            <div className="hidden md:block md:col-span-1 rounded-lg shadow bg-white">
                <TractorFilter />
            </div>
            <div className="p-4 md:col-span-3 rounded-lg shadow bg-white">
                <TractorListings />
            </div>
        </div>

        <div>
            <QuickLinks />
        </div>

        <Footer />

    </div>
  );
}

export default UpcomingTractors;
